import { render } from "./unit-template-view-page.vue?vue&type=template&id=6fdbfa41"
const script = {}

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__